import React from 'react';
import { toast } from 'react-toastify';
import { ToastError } from '../ui/components/Toast';

const forceDownload = (blob, filename) => {
  const a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const downloadResource = (url, filename) => {
  if (!filename) filename = url.split('\\').pop().split('/').pop();
  fetch(url, {
    headers: new Headers({
      // eslint-disable-next-line no-restricted-globals
      Origin: location.origin,
    }),
    mode: 'cors',
  })
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch((e) =>
      toast.error(<ToastError body="Qualcosa è andato storto." />, {
        toastId: 'downloadToast',
      })
    );
};
